import CheckAnimated from "assets/images/animated-check.svg";
import ScrollReveal from "components/common/ScrollReveal";

const ThankYou = () => {
    return (
        <section>
            <div className="container">
                <ScrollReveal variant="scale">
                    <div className="flex flex-col items-center text-center gap-6 max-w-lg mx-auto py-12">
                        <div className="w-32 h-32 flex items-center justify-center rounded-full bg-primary/5">
                            <img
                                src={CheckAnimated}
                                alt="Message sent successfully"
                                className="w-24"
                            />
                        </div>
                        <h2 className="!text-3xl !mb-2">
                            Thank you for reaching out.
                        </h2>
                        <p className="text-secondary/70">
                            We&apos;ve received your message and will respond
                            shortly.
                        </p>
                    </div>
                </ScrollReveal>
            </div>
        </section>
    );
};

export default ThankYou;
